export var Scope = {
    AppleToken: 'AppleToken',
    TapToken: 'TapToken'
};
export var ButtonStyle = {
    Black: 'black',
    White: 'white',
    WhiteOutline: 'white-outline'
};
export var Locale = {
    EN: 'en',
    AR: 'ar',
    FR: 'fr'
};
export var ButtonType = {
    BOOK: 'book',
    BUY: 'buy',
    CHECK_OUT: 'check-out',
    PAY: 'pay',
    PLAIN: 'plain',
    SUBSCRIBE: 'subscribe'
};
export var ThemeMode = {
    DARK: 'dark',
    LIGHT: 'light'
};
export var Edges = {
    STRAIGHT: 'straight',
    CURVED: 'curved'
};
export var MerchantCapabilities = {
    Supports3DS: 'supports3DS',
    SupportsCredit: 'supportsCredit',
    SupportsDebit: 'supportsDebit'
};
export var SupportedNetworks = {
    Amex: 'amex',
    Mada: 'mada',
    MasterCard: 'masterCard',
    Visa: 'visa',
    ChinaUnionPay: 'chinaUnionPay',
    Discover: 'discover',
    Electron: 'electron',
    Jcb: 'jcb',
    Maestro: 'maestro'
};
export var ApplePayVersion = 5;
export var Environment = {
    Production: 'production',
    Sandbox: 'sandbox',
    Beta: 'beta',
    Development: 'development',
    Staging: 'staging'
};
export var RSA_DEV_MW_PUBLIC_KEY = "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC8AX++RtxPZFtns4XzXFlDIxPBh0umN4qRXZaKDIlb6a3MknaB7psJWmf2l+e4Cfh9b5tey/+rZqpQ065eXTZfGCAuBLt+fYLQBhLfjRpk8S6hlIzc1Kdjg65uqzMwcTd0p7I4KLwHk1I0oXzuEu53fU1LSZhWp4Mnd6wjVgXAsQIDAQAB\n-----END PUBLIC KEY-----";
export var RSA_SANDBOX_MW_PUBLIC_KEY = "";
export var RSA_STAGING_MW_PUBLIC_KEY = "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCi9W5jyTvA4Iwv3V5sfNQ7VdSz\n7WqwBbnWFbIUL/GjaaE93mvDv4zbgRSznHaHQPH6pxrMhMh0tV58njkvjHvQ/tvg\npwM8SemNPKEEAPl69tnMvCrJRPh2dWL3OHY8yCW4c38Hyx4fy56Zd5cdoVWfCReu\njCsvASLGz+cfRrj2swIDAQAB\n-----END PUBLIC KEY-----";
export var RSA_BETA_MW_PUBLIC_KEY = "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC9hSRms7Ir1HmzdZxGXFYgmpi3\nez7VBFje0f8wwrxYS9oVoBtN4iAt0DOs3DbeuqtueI31wtpFVUMGg8W7R0SbtkZd\nGzszQNqt/wyqxpDC9q+97XdXwkWQFA72s76ud7eMXQlsWKsvgwhY+Ywzt0KlpNC3\nHj+N6UWFOYK98Xi+sQIDAQAB\n-----END PUBLIC KEY-----";
export var RSA_PRODUCTION_MW_PUBLIC_KEY = "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC9hSRms7Ir1HmzdZxGXFYgmpi3\nez7VBFje0f8wwrxYS9oVoBtN4iAt0DOs3DbeuqtueI31wtpFVUMGg8W7R0SbtkZd\nGzszQNqt/wyqxpDC9q+97XdXwkWQFA72s76ud7eMXQlsWKsvgwhY+Ywzt0KlpNC3\nHj+N6UWFOYK98Xi+sQIDAQAB\n-----END PUBLIC KEY-----";
